<div class="quantity-wrapper" [ngClass]="customClass">
  @if (label) {
  <label class="label">{{ label }}</label>
  }

  <div class="quantity-selector">
    <button class="btn" [disabled]="value <= min" (click)="decrease()">
      <ion-icon name="remove-outline" class="icon" />
    </button>
    <span class="value">{{ value }}</span>
    <button class="btn" [disabled]="value >= max" (click)="increase()">
      <ion-icon name="add-outline" class="icon" />
    </button>
  </div>
</div>
